// Mukti Hospital ERP - Service Worker Registration (Phase 0)
// This file REPLACES the old src/serviceWorkerRegistration.js.
// The exported function name `register()` is kept exactly the same,
// so src/index.js does NOT need any change at all.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  // Service worker only works on the PRODUCTION build (npm run build).
  // During development (npm start) nothing is registered — this is normal.
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Service worker won't work if PUBLIC_URL is on a different origin
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // Running on localhost: check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);
      } else {
        // Not localhost: just register the service worker.
        registerValidSW(swUrl, config);
      }

      // Ask the browser to mark our storage as PERSISTENT so that
      // offline data (IndexedDB) is never auto-deleted by the browser.
      requestPersistentStorage();
    });
  }
}

function requestPersistentStorage() {
  if (navigator.storage && navigator.storage.persist) {
    navigator.storage
      .persist()
      .then((isPersisted) => {
        console.log(`[PWA] Persistent storage granted: ${isPersisted}`);
      })
      .catch(() => {
        // Non-critical: ignore errors silently
      });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[PWA] Service Worker registered:', registration.scope);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content is available; it will be used when all tabs
              // are closed/reloaded. Our SW uses skipWaiting, so a simple
              // reload picks up the new version.
              console.log('[PWA] New version available. Reload to update.');
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Everything has been precached: app is ready for offline use.
              console.log('[PWA] App is ready to work offline.');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[PWA] Service Worker registration failed:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't, reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Unregister.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('[PWA] No internet connection. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
